// **********************************************************
// Sticky Image Text Slider Work
// **********************************************************
const militaryVehicles = document.querySelectorAll('.military-vehicles');
militaryVehicles.forEach((el) => {
  let controllerMilitaryVehicles = null;
  controllerMilitaryVehicles = new ScrollMagic.Controller();
  const parentElement = el.closest('.sc-military-vehicles');
  const accordionTitles = parentElement.querySelectorAll('.military-vehicles__accordion-title');
  const fakeSlides = parentElement.querySelectorAll('.military-vehicles__faker-slide');
  const paginationBullets = parentElement.querySelectorAll('.slider-pagination__bullet');
  const stickyElement = parentElement.querySelector('.military-vehicles__sticky-body');
  const scrollContainer = parentElement.querySelector('.military-vehicles__accordion-container');
  const fakeSlidesWrapper = parentElement.querySelector('.military-vehicles__faker-slides');
  const stickyStartPoint = parentElement.querySelector('.military-vehicles__animation-start');
  const accordions = parentElement.querySelectorAll('.military-vehicles__accordion-item');
  const allImages = parentElement.querySelectorAll('.military-vehicles__images-item');

  // Sticky Image Text Animations
  const initStickyElementScene = () => {
    const moveContainer = new TimelineMax();
    moveContainer.to(scrollContainer, 1, { y: '-30%', ease: Power1.easeInOut });

    // Sticky scene
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyStartPoint,
      duration: `${fakeSlidesWrapper.clientHeight}px`,
      triggerHook: 0,
    })
      .setTween(moveContainer)
      .setPin(stickyElement)
      .addTo(controllerMilitaryVehicles);

    if (isLocal()) {
      scene.addIndicators({ name: 'Sticky' });
    }
  };

  const toggleItems = (elements, toggle, i, bullet) => {
    elements[i].classList.toggle('is-open', toggle);
    bullet[i].classList.toggle('is-active');
  };

  const openAccordion = (element) => {
    gsap.to(element, { height: 'auto', duration: 0.3 });
  };

  const closeAccordion = (element) => {
    gsap.to(element, { height: '0', duration: 0.3 });
  };

  const closeAllAccordions = () => {
    const allAccordions = el.querySelectorAll('.military-vehicles__accordion-item.is-open');
    allAccordions.forEach((accordion) => {
      closeAccordion(accordion.querySelector('.military-vehicles__accordion-text'));
    });
  };

  const initEachSlideScene = () => {
    fakeSlides.forEach((slideElem, i) => {
      const slideAnimation = new TimelineMax();
      const scrollValue = slideElem.getAttribute('data-scroll');
      const content = accordions[i].querySelector('.military-vehicles__accordion-text');

      const scene = new ScrollMagic.Scene({
        triggerElement: slideElem,
        duration: slideElem.clientHeight,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          const scrollableContainer = parentElement.querySelector('.military-vehicles__accordion');

          if (e.scrollDirection === 'FORWARD' && i > 0) {
            toggleItems(accordions, true, i, paginationBullets);
            openAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i < accordions.length - 1) {
            closeAllAccordions();
            toggleItems(accordions, true, i, paginationBullets);
            openAccordion(content);
          }

          removeActiveClass(allImages);
          toggleActiveClass(allImages[i], true);

          slideAnimation.to(scrollableContainer, {
            y: `-${scrollValue}%`,
            duration: 0.6,
            ease: Power1.ease,
          });
        })
        .on('leave', (e) => {
          if (e.scrollDirection === 'FORWARD' && i < accordions.length - 1) {
            closeAllAccordions();
            toggleItems(accordions, false, i, paginationBullets);
            closeAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i > 0) {
            toggleItems(accordions, false, i, paginationBullets);
            closeAccordion(content);
          }
        })
        .addTo(controllerMilitaryVehicles);

      if (isLocal()) {
        scene.addIndicators({ name: `slide ${i}` });
      }
    });
  };

  const initAllScenes = () => {
    initStickyElementScene();
    initEachSlideScene(fakeSlides, accordions, parentElement);
  };

  const handleResize = () => {
    initializeOrDestroyScrollMagic(controllerMilitaryVehicles, initAllScenes);
  };

  if (windowWidth() >= breakpointMd) {
    initAllScenes();
  }

  window.addEventListener('resize', handleResize);

  const scrollToDiv = (element, scrollBehavior) => {
    const elementRect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const topOffset = elementRect.top + scrollTop;
    window.scrollTo({
      top: topOffset + 1,
      behavior: scrollBehavior,
    });
  };

  // Open item on click of title
  accordionTitles.forEach((title) => {
    title.addEventListener('click', (el) => {
      el.preventDefault();
      const itemIndex = el.target.getAttribute('data-item');
      const targetSlide = fakeSlides[itemIndex];
      scrollToDiv(targetSlide, 'instant');
    });
  });

  // Mobile Slider
  const sliderElem = el.querySelector('[data-slider="military-vehicles__slider-mobile-init"]');

  const eventsSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 18,
    speed: 800,
    watchOverflow: true,
    autoHeight: true,
    pagination: {
      el: parentElement.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      prevEl: parentElement.querySelector('.swiper-button-prev'),
      nextEl: parentElement.querySelector('.swiper-button-next'),
    },
  };

  const vehiclesVideoSlider = new Swiper(sliderElem, eventsSliderOptions);

  vehiclesVideoSlider.on('slideChange', (swiper) => {
    const slideIndex = swiper.realIndex;

    removeActiveClass(allImages);
    toggleActiveClass(allImages[slideIndex], true);
  });
});
